import FlagsList from '@/views/Admin/FlagsList/FlagsList.vue';
import { Route } from '../route.model';

const adminFlagsList = new Route(
  '/admin/flags',
  'admin_flags_list',
  FlagsList,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Available Features', // TODO apply i18n
      icon: 'loyalty-widget'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminFlagsList };
export default adminFlagsList;
